import ImageIcon from '@mui/icons-material/Image';
import { Button, Grid, MenuItem, TextField, Tooltip } from "@mui/material";
import Box from "@mui/material/Box";
import React, { useRef, useState } from "react";
import { useSelector } from "react-redux";
import { IReduxState } from "../../store";
import { SITEWEB_SERVER_BASE_URL } from "../../util/apiClient";
import { IEditionPayload } from './interface';

interface IEddProps {
  edition: IEditionPayload;
  setEdition: (x: IEditionPayload) => void;
  setSelectedPhoto: (x: any) => void;
}



const Edit = (props: IEddProps) => {

  //props
  const {
    edition,
    setEdition,
    setSelectedPhoto
  } = props

  //redux
  const { fonctions, services } = useSelector((state: IReduxState) => state.siteWeb);

  //hooks
  const selectPhoto: any = useRef(null);
  const [image, setImage] = useState<string>("");

  //fonctions
  const handleInputChange = (e: any) => {
    const { value, name } = e.target
    setEdition({ ...edition, [name]: value })
  }


  return (
    <Box sx={{ flexGrow: 1, width: "100%" }}>
      <Grid
        container
        spacing={1}
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Grid item md={3} xs={12} sm={3}>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >

            <Grid item md={12} xs={12} sm={12}>
              <div style={{ width: "15vw", height: "30vh", border: "1px solid gray" }}>
                <img
                  src={
                    Object.keys(image).length > 0
                      ? image
                      : `${SITEWEB_SERVER_BASE_URL}/equipeImages/${edition?.photoAgent}`
                  }
                  style={{ width: "15vw", height: "30vh" }}
                />
              </div>
            </Grid>

            <Grid item md={12} xs={12} sm={12}>
              <Tooltip title="Charger l'image descriptive de l'actualité">
                <Button
                  variant="outlined"
                  color="primary"
                  component="label"
                  startIcon={<ImageIcon />}
                  style={{ marginTop: 10 }}
                  onClick={() => {
                    selectPhoto?.current?.click();
                  }}
                >
                  Charger la photo
                </Button>
              </Tooltip>
              <input
                hidden
                multiple
                type="file"
                name="pieceJointe"
                ref={selectPhoto}
                onChange={(e: any) => {
                  const files = e.target.files[0];
                  if (files) {
                    const img = URL.createObjectURL(files);
                    setImage(img);
                    setSelectedPhoto(e.target.files[0]);
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item md={6} xs={12} sm={6}>
          <Grid
            container
            spacing={2}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Grid item md={12} xs={12} sm={12}>
              <TextField
                fullWidth
                size="small"
                name="nomAgent"
                label="Nom complet"
                value={edition.nomAgent}
                onChange={handleInputChange}
              />
            </Grid>

            <Grid item md={12} xs={12} sm={12}>
              <TextField
                fullWidth
                select
                size="small"
                name="idFonction"
                label="Fonction"
                value={edition.idFonction}
                onChange={handleInputChange}
              >
                {fonctions.map((option) => (
                  <MenuItem key={option.idFonction} value={option.idFonction}>
                    {option.fonctionAgent}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>

            <Grid item md={12} xs={12} sm={12}>
              <TextField
                fullWidth
                select
                size="small"
                name="idService"
                label="Service"
                value={edition.idService}
                onChange={handleInputChange}
              >
                {services.map((option) => (
                  <MenuItem key={option.idService} value={option.idService}>
                    {option.libService}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default Edit;





